module.exports = __webpack_public_path__ + "static/media/tour2.c85b5033.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/america-off-balance/tour2.mp4
// module id = 298
// module chunks = 0